import TicketDetail from '../TicketDetail';

export default function HRManagerTicketDetail() {
  return <TicketDetail />;
}
